import { createSelector } from "@reduxjs/toolkit";
import { GetChecklistMcTemplatesApiResponse, openapi } from "../../openapi";
import { IRootState } from "../store";

const EMPTY_TEMPLATES: GetChecklistMcTemplatesApiResponse = [];

const selectShowInDevelopment = (state: IRootState) => state.checklistReducer.showInDevelopment;
export const selectHttpChecklistMcTemplates = createSelector(
  [selectShowInDevelopment, (state: IRootState) => state],
  (showInDevelopment, state) => {
    const q = openapi.endpoints.getChecklistMcTemplates.select({ showInDevelopment })(state);
    return q.data ?? EMPTY_TEMPLATES; // Stabil referens när ingen data finns
  },
);

export const selectTemplateNrId = (state: IRootState) => state.checklistReducer.mcTemplateTestPage.selectedTemplateNrId;
export const selectSelectedChecklistTemplate = createSelector(
  [selectTemplateNrId, selectHttpChecklistMcTemplates],
  (selectedTemplateNrId, templates) => {
    if (!selectedTemplateNrId) return null;
    return templates.find((template) => template.id === selectedTemplateNrId) ?? null;
  },
);
